import { render, staticRenderFns } from "./CurrentLogin-comp.vue?vue&type=template&id=745673cb&scoped=true&"
import script from "./CurrentLogin-comp.vue?vue&type=script&lang=js&"
export * from "./CurrentLogin-comp.vue?vue&type=script&lang=js&"
import style0 from "./CurrentLogin-comp.vue?vue&type=style&index=0&id=745673cb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "745673cb",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
